import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Modal from 'react-modal';
import { IoMdArrowRoundBack } from "react-icons/io";

Modal.setAppElement('#root');

function OrderPage() {
  const [deliveryName, setDeliveryName] = useState('');
  const location = useLocation();
  const navigate = useNavigate();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [orderTopModal, setOrderTopModal] = useState('')
  const [orderBtmModal, setOrderBtmModal] = useState('')
  const [cart, setCart] = useState([]);
  const [quantities, setQuantities] = useState({});
  const [paymentMethod, setPaymentMethod] = useState('coins'); // 'coins', 'comcoins', or 'both'

  const calculateTotalCost = () => {
    return cart.reduce((total, item) => {
      const quantity = quantities[item.id] || 1; // Default to 1 if no quantity is set
      return total + item.price * quantity;
    }, 0);
  };

  const handleCheckout = (e) => {
    e.preventDefault();
    const coinBalance = parseInt(localStorage.getItem('coins')) || 0;
    const comCoinBalance = parseInt(localStorage.getItem('comcoins')) || 0;
    const totalCost = calculateTotalCost();

    let remainingCost = totalCost;
      if (coinBalance + comCoinBalance >= totalCost) {
        const newCoinBalance = Math.max(0, coinBalance - totalCost);
        remainingCost -= coinBalance;
        const newComCoinBalance = Math.max(0, comCoinBalance - remainingCost);
        
        localStorage.setItem('coins', newCoinBalance.toString());
        localStorage.setItem('comcoins', newComCoinBalance.toString());
        localStorage.removeItem('cart');
        setOrderTopModal('Order Successful')
        setOrderBtmModal('Delivery is on its way')
        setModalIsOpen(true);
        window.dispatchEvent(new Event('coinsUpdated'));
      } else {
        setOrderTopModal('Order Unsuccessful')
        setOrderBtmModal('Insufficient funds')
        setModalIsOpen(true);
      }
    };

  const okdone = () => {
    setCart([]);
    localStorage.removeItem('cart');
    setModalIsOpen(false);
  }

  const handleCancelOrder = () => {
    setCart([]);
    localStorage.removeItem('cart');
    setModalIsOpen(false);
    navigate('/shop');
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  const handleGoBack = () => {
    if (window.history.length > 1) {
      // Go back to the previous page if there is history
      navigate(-1);
    } else {
      // Navigate to /shop if there's no history
      navigate('/shop', { state: { cart } });
    }
  };

  const handleQuantityChange = (productId, newQuantity) => {
    setQuantities(prevQuantities => ({
      ...prevQuantities,
      [productId]: newQuantity
    }));
  };

  useEffect(() => {
    const storedCart = JSON.parse(localStorage.getItem('cart')) || [];
    setCart(storedCart);
    const initialQuantities = {};
    storedCart.forEach(product => {
      initialQuantities[product.id] = 1;
    });
    setQuantities(initialQuantities);
  }, []);

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      maxWidth: '800px',  // Adjusted for smaller PC view
      margin: 'auto',
      padding: '20px',
      backgroundColor: '#f9f9f9',
      borderRadius: '8px',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
      gap: '20px',
    }}>
      {/* <button onClick={handleGoBack} style={{
        alignSelf: 'flex-start',
        background: 'none',
        border: 'none',
        color: '#007bff',
        fontSize: '18px',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center'
      }}>
        <IoMdArrowRoundBack style={{ marginRight: '8px' }} />
        Go Back
      </button> */}

      <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
        flex: 1,
      }}>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '20px',
          flex: 1
        }}>
          {/* <form onSubmit={handleCheckout} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
            <div>
              <label htmlFor="deliveryName" style={{ display: 'block', marginBottom: '8px', fontSize: '16px' }}>
                Delivery Name:
              </label>
              <input
                type="text"
                id="deliveryName"
                value={deliveryName}
                onChange={(e) => setDeliveryName(e.target.value)}
                required
                style={{ width: '90%', padding: '10px', fontSize: '16px', border: '1px solid #ddd', borderRadius: '4px' }}
              />
            </div>
            <div>
              <label htmlFor="address" style={{ display: 'block', marginBottom: '8px', fontSize: '16px' }}>Address:</label>
              <textarea
                id="address"
                rows="4"
                required
                style={{ width: '100%', padding: '10px', fontSize: '16px', border: '1px solid #ddd', borderRadius: '4px', boxSizing: 'border-box' }}
              />
            </div>

          </form> */}

          {/* Modal */}
          <Modal
            isOpen={modalIsOpen}
            onRequestClose={closeModal}
            style={{
              alignItems:'center',
              content: {
                padding: '20px',
                borderRadius: '8px',
                maxWidth: '400px',
                margin: 'auto',
                maxHeight:'200px',
                
              },
              overlay: {
                backgroundColor: 'rgba(0, 0, 0, 0.5)'
              }
            }}
          >
            <h2 style={{ marginBottom: '20px' }}>{orderTopModal}</h2>
            <p style={{ marginBottom: '20px' }}>{orderBtmModal}</p>
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
              <button onClick={okdone} style={{
                backgroundColor: '#007bff',
                color: 'white',
                border: 'none',
                padding: '12px 24px',
                cursor: 'pointer',
                borderRadius: '4px'
              }}>
                OK
              </button>
              <button onClick={handleGoBack} style={{
                backgroundColor: '#007bff',
                color: 'white',
                border: 'none',
                padding: '12px 24px',
                cursor: 'pointer',
                borderRadius: '4px'
              }}>
                Go Back
              </button>
            </div>
          </Modal>
        </div>

        <div style={{ flex: 1 }}>
          <h2>Cart Items</h2>
          <div style={{
            width: '100%',
            textAlign: 'left',
            height: '300px',
            overflowY: 'auto',
            border: '1px solid #ddd',
            padding: '20px',
            boxSizing: 'border-box',
            backgroundColor: 'white',
            borderRadius: '8px'
          }}>
            {cart && cart.length > 0 ? (
              <ul style={{ padding: '0', listStyleType: 'none', margin: '0' }}>
                {cart.map((item) => {
                  const quantity = quantities[item.id] || 1;
                  const totalPrice = (item.price * quantity).toFixed(2);

                  return (
                    <li key={item.id} style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                      <img
                        src={item.image}
                        alt={item.name}
                        style={{ width: '60px', height: '60px', objectFit: 'cover', marginRight: '15px' }}
                      />
                      <div>
                        <div style={{ marginBottom: '5px' }}>
                          <strong>{item.name}</strong> - ${item.price.toFixed(2)}
                        </div>
                        <div style={{ marginBottom: '5px' }}>
                          Quantity:
                          <input
                            type="number"
                            min="1"
                            value={quantity}
                            onChange={(e) => handleQuantityChange(item.id, parseInt(e.target.value) || 1)}
                            style={{ width: '60px', marginLeft: '10px', padding: '5px', border: '1px solid #ddd', borderRadius: '4px' }}
                          />
                          <span style={{ marginLeft: '10px' }}> - ${totalPrice}</span>
                        </div>
                      </div>
                    </li>
                  );
                })}
              </ul>
            ) : (
              <p>Your cart is empty</p>
            )}
          </div>
          <div style={{ width: '100%', textAlign: 'right', marginTop: '20px' }}>
            <h3>Total: ${calculateTotalCost().toFixed(2)}</h3>
          </div>
        </div>
        <div style={{ display: 'flex', gap: '10px', flexDirection: 'column', alignItems: 'flex-start' }}>
              <button type="submit" style={{
                backgroundColor: '#007bff',
                color: 'white',
                border: 'none',
                padding: '12px 24px',
                cursor: 'pointer',
                borderRadius: '4px',
                width: '100%'
              }}>
                OK
              </button>
              <button type="button" onClick={handleCancelOrder} style={{
                backgroundColor: '#dc3545',
                color: 'white',
                border: 'none',
                padding: '12px 24px',
                cursor: 'pointer',
                borderRadius: '4px',
                width: '100%'
              }}>
                Cancel Order
              </button>
            </div>
      </div>
    </div>
  );
}

export default OrderPage;
